import { observable, action, decorate } from 'mobx'
import axios from 'axios'

class CompaniesStore {
  constructor () {
    this.state = {
      companies: []
    }
    this.fetchAllCompanies()
  }

  fetchAllCompanies () {
    const url = process.env.REACT_APP_AWS_URL + '/getAllCompanies/'
    axios.get(url)
    .then(response => {
      this.state.companies = response.data.map(info => info.dados)
        .sort((current, next) => current.name.localeCompare(next.name))
    })
    .catch(error => {
      console.log(error)
    })
  }

  getCompany (id) {
    return this.state.companies.find(data => data.id === id)
  }
}

decorate(CompaniesStore, {
  state: observable,
  fetchAllCompanies: action
})

export default CompaniesStore



// WEBPACK FOOTER //
// ./src/stores/companiesStore.js